export default 'https://storage.googleapis.com/hom-frontend-assets/next/assets/homebase/quiz/emoji-neutral.svg'
